const SHOW_DEBUG_MESSAGES_PROP = 'showDebugMessages';

type DebugConsole = Console & {
  showDebugMessages: boolean;
};

function createProxiedConsole() {
  let showDebugMessages = false;

  const proxyHandler: ProxyHandler<Console> = {
    get(target, prop, receiver) {
      if (prop === SHOW_DEBUG_MESSAGES_PROP) {
        return showDebugMessages;
      }
      if (!showDebugMessages) {
        return () => {};
      }
      return Reflect.get(target, prop, receiver);
    },
    set(obj, prop, value) {
      if (prop === SHOW_DEBUG_MESSAGES_PROP) {
        showDebugMessages = value;
        return true;
      }
      return Reflect.set(obj, prop, value);
    },
  };

  return new Proxy(console, proxyHandler) as DebugConsole;
}

const debugConsole = createProxiedConsole();

export default debugConsole;
